<template>
  <div class="main-div">
    <div v-if="isLoggedIn" class="dashboard-layout">
      <div class="sidebar">
        <!-- 恢复完整的用户信息部分 -->
        <div class="user-info">
          <div class="avatar">
            <svg t="1742881942752" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="13999" width="40" height="40">
              <path
                d="M127.99616 846.165333a377.173333 377.173333 0 0 1 218.282667-342.272 309.76 309.76 0 0 0 165.717333 49.237334 309.76 309.76 0 0 0 165.717333-49.237334A377.173333 377.173333 0 0 1 895.99616 846.165333c2.730667 156.16-768 158.805333-768 0z m566.357333-410.794666a229.973333 229.973333 0 0 1-82.944 54.784c-30.378667 13.653333-66.304 19.2-99.413333 19.2-33.194667 0-69.12-5.461333-99.498667-19.2a289.962667 289.962667 0 0 1-82.773333-54.784 227.669333 227.669333 0 0 1-55.296-82.090667c-13.824-30.122667-19.370667-62.976-19.370667-98.645333 0-32.853333 5.546667-65.706667 19.370667-98.56 13.824-30.122667 33.109333-60.245333 55.210667-82.176 24.917333-24.576 52.48-43.776 82.858666-54.698667C445.69216 5.546667 478.801493 0 511.99616 0c33.109333 0 69.12 5.461333 99.413333 19.2 30.378667 13.653333 60.842667 32.853333 82.944 54.698667 24.746667 24.746667 44.202667 52.053333 55.210667 82.176 13.824 30.122667 19.370667 62.976 19.370667 98.56 0 32.938667-5.546667 65.706667-19.370667 98.645333-11.093333 30.122667-30.378667 57.514667-55.210667 82.090667z"
                fill="#F8B62D" p-id="14000" data-spm-anchor-id="a313x.search_index.0.i0.4b053a81CDm7h2"
                class="selected">
              </path>
            </svg>
          </div>
          <div class="user-details">
            <div class="username">{{ username }}</div>
            <div class="user-id">ID: {{ userId }}</div>
            <!-- <div class="join-date">{{ formatCreatedTime }}</div> -->
          </div>
        </div>

        <!-- 其他导航菜单保持不变 -->
        <div class="menu-list">
          <a @click="navigateToSection('courses')" class="menu-item"
            :class="{ 'active': currentSection === 'courses' }">
            <span>课程收藏</span>
          </a>
          <a @click="navigateToSection('questionConfig')" class="menu-item"
            :class="{ 'active': currentSection === 'questionConfig' }">
            <span>OCS配置</span>
          </a>
          <!-- 退出登录按钮保持不变 -->
          <a @click="showLogoutConfirm" class="menu-item logout-btn">
            <span>退出登录</span>
          </a>
        </div>
        <div class="developer-info" @click="Profile">
          由M0zey开发
          <svg t="1745846730970" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10210" width="200" height="200"><path d="M359.86136 0.00382a51.199909 51.199909 0 0 1 0 102.399818H153.599727a51.199909 51.199909 0 0 0-51.199909 51.199909V870.400273a51.199909 51.199909 0 0 0 51.199909 51.199909h716.796726a51.199909 51.199909 0 0 0 51.199909-51.199909V665.600637a51.199909 51.199909 0 0 1 102.399818 0v204.799636a153.599727 153.599727 0 0 1-153.599727 153.599727H153.599727A153.599727 153.599727 0 0 1 0 870.400273V153.603547A153.599727 153.599727 0 0 1 153.599727 0.00382h206.261633z m620.980897 0.584999h2.193996a29.256948 29.256948 0 0 1 5.119991 1.243998h0.730998a24.209957 24.209957 0 0 1 5.85199 2.559995 56.2469 56.2469 0 0 1 5.85099 3.071995l2.193996 1.315997a27.793951 27.793951 0 0 1 5.851989 5.412991l-0.731998-1.243998 0.731998 0.731999v0.511999l4.387993 4.168992 1.462997 2.193996a84.113851 84.113851 0 0 1 7.314987 13.969976v0.512999c0.730999 2.193996 0.730999 4.460992 1.461997 6.728988v2.119996a25.892954 25.892954 0 0 1 0.731999 7.314987v332.799408a51.199909 51.199909 0 0 1-102.399818 0V174.813509l-373.759336 373.393337a51.199909 51.199909 0 0 1-70.215875 1.900996l-2.193996-1.900996a52.149907 52.149907 0 0 1 0-72.411872l373.758336-373.392336H639.997863a51.199909 51.199909 0 0 1-51.199909-48.639914v-2.559995a51.199909 51.199909 0 0 1 51.199909-51.199909h332.798408a41.105927 41.105927 0 0 1 7.313987 0.584999h0.731999z m0 0" fill="#a0a0a0" p-id="10211"></path></svg>
          </div>
      </div>

      <div class="main-content">
        <div class="content-wrapper">
          <!-- 显示API调用次数 -->
          <div class="api-calls-info">
            <div class="api-calls-card">
              <div class="api-calls-icon">
                <svg t="1742882942752" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24">
                  <path
                    d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m0 64c-200.298667 0-362.666667 162.368-362.666667 362.666667s162.368 362.666667 362.666667 362.666667 362.666667-162.368 362.666667-362.666667-162.368-362.666667-362.666667-362.666667z m32 298.666667v256h-64v-256h64z m0-128v64h-64v-64h64z"
                    fill="#F8B62D"></path>
                </svg>
              </div>
              <div class="api-calls-content">
                <div class="api-calls-title">剩余API调用次数</div>
                <div class="api-calls-count">{{ apiCallsRemaining }}</div>
              </div>
              <!-- 添加购买按钮 -->
              <button class="free-btn" @click="showFreeTokenModal = true">免费获取</button>
              <button class="purchase-btn" @click="showPurchaseModal = true">购买</button>
            </div>
          </div>

          <!-- 添加购买弹窗 -->
          <PurchaseModal :show="showPurchaseModal" @close="showPurchaseModal = false" />
          <!-- 添加免费获取弹窗 -->
          <FreeTokenModal :show="showFreeTokenModal" @close="showFreeTokenModal = false"
            @reward-claimed="updateApiCallsRemaining" />

          <!-- 课程部分 -->
          <div id="courses" class="section" v-show="currentSection === 'courses'">


            <div v-if="loading" class="loading-indicator">
              <div class="spinner"></div>
              <p>加载中...</p>
            </div>

            <div v-else-if="favoriteCourses.length === 0" class="empty-state">
              <p>暂无收藏课程</p>
            </div>

            <div v-else class="courses-grid">
              <div v-for="course in favoriteCourses" :key="course.id" class="course-card"
                @click="handleCourseClick(course)">
                <div class="course-image" :style="getCourseImageStyle(course)">
                  <button class="favorite-btn is-favorite" @click.stop="handleFavoriteClick(course.id)" title="取消收藏">
                    ❤
                  </button>
                </div>
                <div class="course-content">
                  <h3 class="course-title">{{ course.name || course.title }}</h3>
                  <p class="course-description">
                    {{ course.teacherName ? `讲师: ${course.teacherName}` : (course.author ? `讲师: ${course.author}` :
                    '暂无讲师信息') }}
                  </p>
                  <div class="course-meta">
                    <span class="course-count">试卷数量: {{ course.papers ? course.papers.length : 0 }}</span>
                    <span class="course-semester">{{ getSemesterLabel(course) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 题库配置部分 -->
          <div id="questionConfig" class="section" v-show="currentSection === 'questionConfig'">
            
            <div class="config-content full-width">
              <div class="config-card">
                <div class="json-display-container">
                  <!-- 在 json-actions 中添加教程按钮 -->
                  <div class="json-header">
                    <div class="json-actions">

                      <button @click="resetJsonData" class="reset-btn">
                        <span class="btn-icon"><svg t="1749530787637" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10892" width="200" height="200"><path d="M895.701333 391.424h-172.629333a39.850667 39.850667 0 1 1 0-79.701333h69.333333a344.490667 344.490667 0 0 0-281.813333-146.048 345.258667 345.258667 0 1 0 345.301333 345.258666 39.850667 39.850667 0 1 1 79.658667 0c0 234.666667-190.293333 424.96-424.96 424.96-234.666667 0-424.96-190.293333-424.96-424.96 0-234.666667 190.293333-424.96 424.96-424.96a423.765333 423.765333 0 0 1 345.301333 177.834667V192.213333a39.850667 39.850667 0 1 1 79.658667 0V351.573333a39.850667 39.850667 0 0 1-39.850667 39.850667z" p-id="10893"></path></svg></span>
                      <span class="btn-text">重置</span>
                      </button>

                      <button @click="copyJsonToClipboard" class="copy-btn">
                        <span class="btn-icon" v-if="!copied">
                          <svg t="1749530288180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7853" width="200" height="200">
                            <path d="M96 224l160-160h351.872C643.296 64 672 92.48 672 128.128V192h-64V159.968A31.776 31.776 0 0 0 576.032 128H352v160H160v448.032c0 17.92 14.304 31.968 31.968 31.968H256v64H160.128A63.968 63.968 0 0 1 96 767.872V224z m192-96L192 224h96V128z m64 288l160-160h352.16C899.424 256 928 284.512 928 319.712V896.32A63.744 63.744 0 0 1 864.16 960h-448.32A63.776 63.776 0 0 1 352 896.288V416z m192-96l-128 128h128v-128z m64 192h-192v352.224a32 32 0 0 0 32.224 31.776h383.552A32 32 0 0 0 864 864.224V351.776A32 32 0 0 0 831.776 320H608v192z" p-id="7854"></path>
                          </svg>
                        </span>
                        <span class="btn-icon" v-else>
                          <svg t="1749531073420" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15547" width="200" height="200"><path d="M335.872 734.208 108.544 506.88c-24.576-24.576-65.536-24.576-90.112 0-24.576 24.576-24.576 65.536 0 90.112l271.36 271.36c20.48 20.48 52.224 24.576 75.776 10.24 6.144-3.072 11.264-7.168 16.384-11.264l622.592-622.592c24.576-24.576 24.576-65.536 0-90.112-24.576-24.576-65.536-24.576-90.112 0L335.872 734.208z"  p-id="15548"></path></svg>
                        </span>
                        <span class="btn-text" v-if="!copied">复制</span>
                        <span class="btn-text" v-else>复制</span>
                      </button>
                      <button @click="openTutorial" class="tutorial-btn">
                        <span class="btn-icon">?</span> 配置教程
                      </button>
                      
                    </div>
                    
                  </div>
                  <div  class="course-tip"> OCS是一款支持学习通，智慧树等平台的网课助手，ZError可以为其提供题库支持。<a href="https://ocs.csid.cc/OCS%E7%BD%91%E8%AF%BE%E5%8A%A9%E6%89%8B.user.js" target="_blank" class="plugin-link">点击安装</a>（安装前请先安装<a href="https://docs.scriptcat.org/" target="_blank" class="plugin-link">脚本猫</a>，连接失败请点击配置教程）</div>
                  <pre class="json-content"><code v-html="formattedJson"></code></pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 添加题集弹窗 -->


      <!-- 退出确认弹窗保持不变 -->
      <div class="logout-modal" v-if="showLogoutModal">
        <div class="modal-content">
          <h3>确认退出</h3>
          <p>您确定要退出登录吗？</p>
          <div class="modal-buttons">
            <button @click="cancelLogout" class="cancel-btn">取消</button>
            <button @click="confirmLogout" class="confirm-btn-window">确认</button>
          </div>
        </div>
      </div>

      <!-- 添加重置确认弹窗 -->
      <div class="logout-modal" v-if="showResetModal">
        <div class="modal-content">
          <h3>确认重置</h3>
          <p>您确定要重置配置数据吗？原先的题库配置将会失效</p>
          <div class="modal-buttons">
            <button @click="cancelReset" class="cancel-btn">取消</button>
            <button @click="confirmReset" class="confirm-btn-window">确认</button>
          </div>
        </div>
      </div>

      <!-- 添加取消收藏确认弹窗 -->
      <div class="logout-modal" v-if="showUnfavoriteModal">
        <div class="modal-content">
          <h3>确认取消收藏</h3>
          <p>您确定要取消收藏此课程吗？</p>
          <div class="modal-buttons">
            <button @click="cancelUnfavorite" class="cancel-btn">取消</button>
            <button @click="confirmUnfavorite" class="confirm-btn-window">确认</button>
          </div>
        </div>
      </div>

      <!-- 在最外层添加 CourseDetailModal 组件 -->
      <CourseDetailModal :course="expandedCourse" :click-position="clickPosition" :animation-active="animationActive"
        :homework-resources="homeworkResources" :exam-resources="examResources" :test-resources="testResources"
        :active-tab="activeTab" @close="closeExpandedCourse" @transition-end="handleTransitionEnd"
        @resource-click="goToExamPaper" @update:active-tab="activeTab = $event" />

      <!-- 现有的退出确认弹窗等保持不变 -->
    </div>
  </div>
</template>

<script>
import '@/styles/dashboard.css'; // 引入样式文件
import axios from 'axios'; // 添加 axios 导入
import apiConfig from '@/config/api'; // 添加 apiConfig 导入
import CourseDetailModal from '@/components/CourseDetailModal.vue'; // 导入课程详情组件
import PurchaseModal from '@/components/PurchaseModal.vue'; // 导入购买弹
import FreeTokenModal from '@/components/FreeTokenModal.vue'; // 导入免费

export default {
  components: {
    CourseDetailModal, // 注册组件
    PurchaseModal, // 注册购买弹窗组件
    FreeTokenModal // 注册免费获取弹窗组件
  },

  data() {
    return {
      isLoggedIn: false,
      username: "",
      userId: "", // 添加用户ID属性
      token: "",
      api_token: "",
      createdTime: localStorage.getItem("createdTime") || '',
      currentSection: 'questionConfig', // 修改默认值为 'questionConfig'
      showLogoutModal: false,
      showResetModal: false,
      showUnfavoriteModal: false, // 添加取消收藏确认弹窗状态
      showPurchaseModal: false, // 添加购买弹窗状态
      showAddQuestionModal: false, // 添加题目弹窗状态
      showFreeTokenModal: false, // 添加免费获取弹窗状态
      courseToUnfavorite: null, // 添加要取消收藏的课程ID
      apiCallsRemaining: 200,
      copied: false,
      favoriteCourses: [],
      loading: false,
      expandedCourse: null,
      clickPosition: null,
      animationActive: false,
      activeTab: 'homework',
      homeworkResources: [],
      examResources: [],
      testResources: [],
      prettyJson: `[
      {
        "name": "ZE题库",
        "homepage": "https://tiku.zerror.cc/",
        "url": "${apiConfig.baseURL}/api/query",
        "method": "post",
        "type": "GM_xmlhttpRequest",
        "data": {
          "title": "\${title}",
          "options": "\${options}",
          "type": "\${type}"
        },
        "headers": {
            "Content-Type": "application/json",
            "Authorization": "Bearer token加载中"
        },
        "handler": "return (res)=>res.data.code === 0 ? [res.data.msg, undefined] : [undefined,res.data.data]"
      } 
    ]`,
      hasLoadedCourses: false, // 添加标记，用于记录是否已加载过课程
    };
  },
  computed: {
    formatCreatedTime() {
      if (!this.createdTime) return '';
      const date = new Date(this.createdTime);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    // 添加格式化JSON的计算属性
    formattedJson() {
      try {
        // 尝试解析JSON字符串为对象
        const jsonObj = JSON.parse(this.prettyJson);
        // 重新格式化为带缩进的字符串
        const formatted = JSON.stringify(jsonObj, null, 2);

        // 添加简单的语法高亮 - 修复转义字符问题
        return formatted
          .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function (match) {
            let cls = 'json-number';
            if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                cls = 'json-key';
              } else {
                cls = 'json-string';
              }
            } else if (/true|false/.test(match)) {
              cls = 'json-boolean';
            } else if (/null/.test(match)) {
              cls = 'json-null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
          });
      } catch (e) {
        // 如果解析失败，直接返回原始文本
        console.error('JSON格式化失败:', e);
        return this.prettyJson;
      }
    }
  },
  created() {
    // createFloatingImageWorld
    this.checkLoginStatus();

  },
  methods: {

    // 获取题集列表
    async fetchQuestionSets() {
      this.loadingSets = true;
      try {
        const response = await axios.get(`${apiConfig.baseURL}${apiConfig.getAllSets}`, {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        });

        if (response.data.success && response.data.data?.sets) {
          this.questionSets = response.data.data.sets;
        } else {
          console.error('获取题集失败:', response.data.message);
          this.questionSets = [];
        }
      } catch (error) {
        console.error('获取题集错误:', error);
        this.questionSets = [];
      } finally {
        this.loadingSets = false;
      }
    },
    checkLoginStatus() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.isLoggedIn = false;
        this.$router.push('/login');
        return;
      }

      this.token = token;
      this.api_token = localStorage.getItem("api_token");
      this.isLoggedIn = true;
      this.username = localStorage.getItem("nickname") || "User";
      this.createdTime = localStorage.getItem("createdTime") || '';

      // 添加获取用户信息的请求
      this.fetchUserInfo();

    },

    // 修改获取用户信息的方法
    async fetchUserInfo() {
      try {
        const response = await axios.get(`${apiConfig.appURL}/api/user/info`, {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        });

        if (response.data.success && response.data.data) {
          // 更新用户信息
          const userData = response.data.data;
          this.api_token = userData.api_token;
          this.username = userData.nickname;
          this.createdTime = userData.created_at;
          this.userId = userData.id || '未知'; // 添加获取用户ID

          // 更新API调用次数
          if (userData.api_call_count !== undefined) {
            this.apiCallsRemaining = userData.api_call_count;
          }

          // 更新本地存储
          localStorage.setItem("api_token", userData.api_token);
          localStorage.setItem("nickname", userData.nickname);
          localStorage.setItem("createdTime", userData.created_at);
          localStorage.setItem("userId", userData.id); // 存储用户ID

          // 更新 prettyJson 中的 token
          this.updatePrettyJson();

          console.log('用户信息已更新:', userData);
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        
        // 检查是否为401错误（未授权）
        if (error.response && error.response.status === 401) {
          console.log('用户未授权，清除token并跳转到登录页');
          // 清除token和相关信息
          this.token = "";
          this.username = "";
          this.isLoggedIn = false;
          localStorage.removeItem("token");
          localStorage.removeItem("nickname");
          localStorage.removeItem("createdTime");
          localStorage.removeItem("userId");
          localStorage.removeItem("api_token");
          
          // 跳转到登录页
          this.$router.push("/login");
        }
      }
    },

    // 添加获取收藏课程的方法
    async fetchFavoriteCourses() {
      this.loading = true;
      try {
        const response = await axios.get(`${apiConfig.appURL}/api/favorites/list`, {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        });

        if (response.data.success) {
          // 修改这里：从 response.data.data.courses 获取课程数据
          if (response.data.data && response.data.data) {
            this.favoriteCourses = Array.isArray(response.data.data)
              ? response.data.data
              : [];
            console.log('收藏课程数据:', this.favoriteCourses);
          } else {
            console.error('获取收藏课程失败: 返回数据结构不正确');
            this.favoriteCourses = [];
          }
        } else {
          console.error('获取收藏课程失败:', response.data.message);
          this.favoriteCourses = [];
        }
      } catch (error) {
        console.error('获取收藏课程错误:', error);
        this.favoriteCourses = [];
      } finally {
        // 确保无论如何都会设置 loading 为 false
        this.loading = false;
      }
    },

    // 添加更新 prettyJson 的方法
    updatePrettyJson() {
      this.prettyJson = `[
      {
        "name": "ZE题库",
        "homepage": "https://tiku.zerror.cc/",
        "url": "${apiConfig.baseURL}/api/query",
        "method": "post",
        "type": "GM_xmlhttpRequest",
        "data": {
          "title": "\${title}",
          "options": "\${options}",
          "type": "\${type}"
        },
        "headers": {
            "Content-Type": "application/json",
            "Authorization": "Bearer ${this.api_token}"
        },
        "handler": "return (res)=>res.data.code === 0 ? [res.data.msg, undefined] : [undefined,res.data.data]"
      } 
    ]`;
    },

    // 添加获取课程图片样式的方法
    getCourseImageStyle(course) {
      const baseStyle = {
        width: '100%',
        height: '160px'
      };

      if (course.imgUrl) {
        return {
          ...baseStyle,
          backgroundImage: `url(${course.imgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      }

      return {
        ...baseStyle,
        background: 'linear-gradient(45deg, #f8b62d 25%, #ffcd5d 25%, #ffcd5d 50%, #f8b62d 50%, #f8b62d 75%, #ffcd5d 75%, #ffcd5d 100%)',
        backgroundSize: '40px 40px'
      };
    },

    // 修改处理收藏按钮点击方法，显示确认弹窗
    handleFavoriteClick(courseId) {
      this.courseToUnfavorite = courseId;
      this.showUnfavoriteModal = true;
    },

    // 取消取消收藏
    cancelUnfavorite() {
      this.showUnfavoriteModal = false;
      this.courseToUnfavorite = null;
    },

    // 确认取消收藏
    async confirmUnfavorite() {
      try {
        const token = this.token;
        if (!token) {
          alert('请先登录后再操作');
          return;
        }

        // 发送取消收藏请求
        const response = await axios.delete(`${apiConfig.appURL}/api/favorites/remove`, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          data: { courseId: this.courseToUnfavorite }
        });

        if (response.data.success) {
          // 从收藏列表中移除该课程
          this.favoriteCourses = this.favoriteCourses.filter(course => course.id !== this.courseToUnfavorite);
          console.log('取消收藏成功');
        } else {
          console.error('取消收藏失败:', response.data.message);
        }
      } catch (error) {
        console.error('取消收藏请求错误:', error);
      } finally {
        this.showUnfavoriteModal = false;
        this.courseToUnfavorite = null;
      }
    },

    // 修改 getSemesterLabel 方法以兼容不同的日期字段
    getSemesterLabel(course) {
      const dateString = course.startDate || course.time;
      if (!dateString) return '';

      const dateMatch = dateString.match(/\d{4}-(\d{2})-\d{2}/);
      if (!dateMatch) return '';

      const month = parseInt(dateMatch[1], 10);

      return month >= 1 && month <= 6 ? '春季学期' : '秋季学期';
    },



    navigateToSection(sectionId) {
      this.currentSection = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }

      // 只在第一次切换到课程页面时加载课程数据
      if (sectionId === 'courses' && !this.hasLoadedCourses) {
        this.fetchFavoriteCourses();
        this.hasLoadedCourses = true;
      }
    },

    // 添加显示退出确认弹窗方法
    showLogoutConfirm() {
      this.showLogoutModal = true;
    },

    // 取消退出
    cancelLogout() {
      this.showLogoutModal = false;
    },

    // 确认退出
    confirmLogout() {
      this.logout();
      this.showLogoutModal = false;
    },

    logout() {
      this.token = "";
      this.username = "";
      this.isLoggedIn = false;
      localStorage.removeItem("token");
      localStorage.removeItem("nickname");
      localStorage.removeItem("createdTime");
      this.$router.push("/login");
    },

    // 添加复制JSON到剪贴板的方法
    copyJsonToClipboard() {
      navigator.clipboard.writeText(this.prettyJson).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }).catch(err => {
        console.error('复制失败:', err);
      });
    },

    // 添加重置JSON数据的方法
    // 添加显示重置确认弹窗方法
    showResetConfirm() {
      this.showResetModal = true;
    },

    // 取消重置
    cancelReset() {
      this.showResetModal = false;
    },



    // 修改重置JSON数据的方法
    resetJsonData() {
      this.showResetConfirm();
    },


    // 确认重置
    confirmReset() {
      this.resetApiToken();
      this.showResetModal = false;
    },

    // 添加重置API Token的方法
    async resetApiToken() {
      try {
        // 发送重置token请求
        const response = await axios.post(`${apiConfig.appURL}${apiConfig.resetTokenURL}`, {}, {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        });

        if (response.data.success && response.data.data) {
          // 更新API token
          this.api_token = response.data.data.api_token;

          // 更新本地存储
          localStorage.setItem("api_token", this.api_token);

          // 更新JSON显示
          this.updatePrettyJson();

          // 显示成功消息
          // alert('API Token 已成功重置');
          console.log('API Token 已重置:', this.api_token);
        } else {
          console.error('重置API Token失败:', response.data.message);
          alert('重置API Token失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('重置API Token请求错误:', error);
        alert('重置API Token请求错误，请稍后再试');
      } finally {
        this.showResetModal = false;
      }
    },
    // 添加处理课程点击的方法
    handleCourseClick(course, event) {
      if (event && event.currentTarget) {
        const rect = event.currentTarget.getBoundingClientRect();
        this.clickPosition = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height
        };
      }

      // 获取年份
      const year = course.startDate ? course.startDate.substring(0, 4) : '';

      this.expandedCourse = {
        id: course.id,
        title: course.name || course.title,
        description: course.description || `${year}年课程，包含 ${course.papers ? course.papers.length : 0} 个试卷`,
        papers: course.papers || [],
        imgUrl: course.imgUrl, // 添加图片 URL
        author: course.teacherName || '未知讲师', // 添加教师信息
        time: course.startDate || course.time || '未知日期'
      };

      // 根据试卷类型分类
      this.homeworkResources = (course.papers || [])
        .filter(paper => paper.type === '作业')
        .map(paper => ({
          id: paper.id,
          title: paper.paperName || paper.title,
          type: paper.type,
          date: paper.publishTime ? paper.publishTime.split('T')[0] : '',
          endTime: paper.endTime ? paper.endTime.split('T')[0] : ''
        }));

      this.examResources = (course.papers || [])
        .filter(paper => paper.type === '考试')
        .map(paper => ({
          id: paper.id,
          title: paper.paperName || paper.title,
          type: paper.type,
          date: paper.publishTime ? paper.publishTime.split('T')[0] : '',
          endTime: paper.endTime ? paper.endTime.split('T')[0] : ''
        }));

      this.testResources = (course.papers || [])
        .filter(paper => paper.type === '测验')
        .map(paper => ({
          id: paper.id,
          title: paper.paperName || paper.title,
          type: paper.type,
          date: paper.publishTime ? paper.publishTime.split('T')[0] : '',
          endTime: paper.endTime ? paper.endTime.split('T')[0] : ''
        }));

      // 添加类以显示遮罩层
      document.body.classList.add('course-expanded');

      this.$nextTick(() => {
        this.animationActive = true;
      });
    },

    // 关闭展开的课程详情
    closeExpandedCourse() {
      this.animationActive = false;
      this.expandedCourse = null;
      document.body.classList.remove('course-expanded');
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    },

    // 添加过渡结束的处理方法
    handleTransitionEnd() {
      // 过渡结束后执行清理操作
      if (!this.expandedCourse) {
        document.body.classList.remove('course-expanded');
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
      }
    },

    Profile() {
      window.open('https://bonjour.bio/m0zey', '_blank');
    },

    // 添加跳转到试卷页面的方法
    goToExamPaper(item) {
      console.log('跳转到试卷页面，试卷ID:', item.id);

      // 构建路由路径，使用试卷的实际ID
      this.$router.push({
        name: 'ExamPaper',
        params: {
          id: item.id,
          fromDashboard: 'true'
        }
      });
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '未知';
      return dateString.split(' ')[0].replace(/-/g, '/');
    },
    openTutorial() {
    window.open('https://pages.zaizhexue.top/home/API', '_blank');
  },

  },


};
</script>
